<template>
  <div id="access-facility-information">
    <call />
    <pop-alert />
    <!-- header -->
    <top-bar title="アクセス・施設案内" backUrl="/"/>
    <!-- main -->
    <main>
      <!-- nav-bot -->
      <footer-app></footer-app>
      <iframe class="access-iframe" :src="accessUrl" width="100%"></iframe>
    </main>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import Footer from "../components/Footer.vue";
import { Tenant } from "../plugin/mixin.js";
import { Common } from "../common/common.js";
import PopAlert from "../components/PopAlert.vue";
import { getShop } from "../store/firestore";
import TopBar from "../components/TopBar.vue";

export default Vue.extend({
  name: "StoreLocation",
  components: {
    'footer-app': Footer,
    PopAlert,
    TopBar
  },
  async created() {
    const shopData = await getShop(this.shopId);
    if (shopData) {
      this.accessUrl = shopData.accessUrl;
    }
  },
  data() {
    return {
      accessUrl: ""
    }
  },
  mixins: [Tenant],
  mounted() {
    Common.initDom();
  }
});
</script>